import { render } from "./CompanyProject.vue?vue&type=template&id=7701284c&scoped=true"
import script from "./CompanyProject.vue?vue&type=script&lang=js"
export * from "./CompanyProject.vue?vue&type=script&lang=js"

import "./CompanyProject.vue?vue&type=style&index=0&id=7701284c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7701284c"]])

export default __exports__